import { RAZORPAY_KEY_ID } from "@/utils/payment";

export const API_CONFIG = {
    API_GATEWAY: process.env.NEXT_PUBLIC_API_GATEWAY || "http://localhost:8000/api/v1",
    COMMERCE_API_URL: process.env.NEXT_PUBLIC_COMMERCE_API_URL || "http://localhost:8000/api/v1",
    EMAIL_SERVICE_URL: process.env.NEXT_PUBLIC_EMAIL_SERVICE_URL || "http://localhost:8001/send-email",
    PAYMENT_EMAIL_SERVICE_URL: process.env.NEXT_PUBLIC_PAYMENT_EMAIL_SERVICE_URL || "http://localhost:8001/send-payment-email",
    PAYMENT_ATTEMPT_NOTIFICATION_URL: process.env.NEXT_PUBLIC_PAYMENT_ATTEMPT_NOTIFICATION_URL || "http://localhost:8001/send-payment-attempt-notification-admin",
    TENANT_ID: process.env.NEXT_PUBLIC_TENANT_ID || "a273d0d3-cf97-4925-8705-befe66c69475",
    RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "",
    CLASSIFICATION_API_BASE: process.env.NEXT_PUBLIC_CLASSIFICATION_API_BASE || "http://localhost:8000/api/v1",
    // TODO: API_GATEWAY_ADMIN has a legacy double-/v1 issue in call sites — needs audit before changing
    API_GATEWAY_ADMIN: process.env.NEXT_PUBLIC_API_GATEWAY_ADMIN || "http://localhost:8000/api/v1/v1",
    NEWSLETTER_SUBSCRIPTION_URL: process.env.NEXT_PUBLIC_NEWSLETTER_SUBSCRIPTION_URL || "http://localhost:8001/send-newsletter-subscription",
    RAZORPAY_KEY_ID: process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID || "rzp_test_SgtOpcMieWi3HR",
    LEADS_URL: process.env.NEXT_PUBLIC_LEADS_URL || "http://localhost:8000/api/v1/public/leads",
};
